import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  posthog,
  isPostHogEnabled,
  sanitizePath,
  sanitizeSearch,
} from "@/lib/posthog";

export function PostHogPageviews() {
  const routeLocation = useLocation();

  useEffect(() => {
    if (!isPostHogEnabled()) return;
    const safePath = sanitizePath(routeLocation.pathname);
    const safeSearch = sanitizeSearch(routeLocation.search);
    const safeUrl = window.location.origin + safePath + safeSearch;
    posthog.capture("$pageview", {
      $current_url: safeUrl,
      pathname: safePath,
      search: safeSearch,
    });
  }, [routeLocation.pathname, routeLocation.search]);

  return null;
}
